import { appendFileSync } from "node:fs";
import type { BootLogger } from "./types.js";

export const BOOTSTRAP_LOG_PATH = "/tmp/claudespace-bootstrap.log";

export function createBootLogger(filePath: string | undefined = BOOTSTRAP_LOG_PATH): BootLogger {
  const emit = (line: string): void => {
    process.stdout.write(`${line}\n`);
    if (filePath) {
      try {
        appendFileSync(filePath, `${line}\n`);
      } catch {
        // The file sink is best-effort; stdout is the durable channel (kubectl logs).
      }
    }
  };
  return { info: emit, warn: emit, error: emit };
}
